import { TopBar } from './components/TopBar';
import { ToolBar } from './components/ToolBar';
import { Modals } from './components/Modals';
import { NavBar } from './components/NavBar';
import { Flex } from '../GlobalComponents/Flex';

export const Header: React.FC = () => {
	return (
		<>
			<Flex $flexDirection="column" $width="100%" $alignItems="center">
				<TopBar />
				<NavBar />
				<Flex
					$justifyContent="center"
					className="shadow"
					style={{
						zIndex: 999
					}}
				>
					<ToolBar />
				</Flex>
			</Flex>
			<Modals />
		</>
	);
};
